
import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";



import Home from './pages/Home';
import ProgramServices from './pages/ProgramServices';
import Team from './pages/Team';
import AboutUs from './pages/About';
import NotFound from './pages/NotFound'


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Program&Services" element={<ProgramServices />} />
        <Route path="/Team" element={<Team />} />
        <Route path="/About-Us" element={<AboutUs />} />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
